import { Directive, HostBinding, OnChanges, SimpleChanges } from '@angular/core';
import { DropdownDirective } from './dropdown.directive';

@Directive({
    selector: '[rsDropdownMenu]'
})
export class DropdownMenuDirective implements OnChanges {
    @HostBinding('class.dropdown-menu') dropdownMenu = true;
    @HostBinding('class.show') get isOpen() {
        return this.dropdown.isOpen;
    }

    constructor(
        public dropdown: DropdownDirective
    ) { }

    ngOnChanges(changes: SimpleChanges): void {
        console.log(changes);
    }
}
